import { BenefitUsageRow } from '@spike/memberships-action';

export const itemTypeLabel = (itemType: BenefitUsageRow['itemType']) => {
    switch (itemType) {
        case 'service':
            return 'Service';
        case 'addon':
            return 'Add-on';
        default:
            return 'Product';
    }
};

export const planTypeLabel = (enrollmentType: BenefitUsageRow['enrollmentType']) =>
    enrollmentType === 'package' ? 'Package' : 'Membership';

export const benefitTypeLabel = (benefitKind: BenefitUsageRow['benefitKind']) =>
    benefitKind === 'discount' ? 'Discount applied' : 'Used';

export const formatDiscount = (amount: number | null) => (amount == null ? '' : `$${amount.toFixed(2)}`);

const categoryLabel = (slug: string) => slug.charAt(0).toUpperCase() + slug.slice(1);

// The backend returns the raw slugs (add-ons can carry several, comma separated).
export const serviceCategoryLabel = (value: string | null) =>
    value
        ? value
              .split(',')
              .map(slug => categoryLabel(slug.trim()))
              .join(', ')
        : '';
